import { StrengthMeter } from '@/components/strength-meter/StrengthMeter';
import { socketClient } from '@/core/node-client';

// This class handles the interface for the square blocks used on the currency strength meter
export class StrengthMeterInterface {
  constructor(selectorName, argumentsFunction, typeCalculator) {
    this.strengthMeterHolder = document.querySelector(selectorName);
    this.listTfChecks =
      this.strengthMeterHolder.querySelectorAll('.js-tf-check');
    this.listCurrencyChecks =
      this.strengthMeterHolder.querySelectorAll('.js-currency-check');
    this.listGroupChecks =
      this.strengthMeterHolder.querySelectorAll('.js-group-check');
    this.colorButtons =
      this.strengthMeterHolder.querySelectorAll('.js-choose-color');
    this.argumentsFunction = argumentsFunction;
    this.typeCalculator = typeCalculator;

    this.addUiListeners();
    this.updateGroupButtons();

    // Class method bindings
    this.updateGroupButtons = this.updateGroupButtons.bind(this);
    this.addUiListeners = this.addUiListeners.bind(this);
    this.initializeUserInterface = this.initializeUserInterface.bind(this);
    this.createNecessaryList = this.createNecessaryList.bind(this);
    this.createPairGroups = this.createPairGroups.bind(this);
  }

  updateGroupButtons() {
    const listActiveGroups = [];
    this.listCurrencyChecks.forEach((check) => {
      if (check.classList.contains('enabled')) {
        if (!listActiveGroups.includes(check.dataset.group)) {
          listActiveGroups.push(check.dataset.group);
        }
      }
    });
    this.listGroupChecks.forEach((groupCheck) => {
      if (listActiveGroups.includes(groupCheck.dataset.group)) {
        groupCheck.classList.add('enabled');
      } else {
        groupCheck.classList.remove('enabled');
      }
    });
  }

  addUiListeners() {
    //hide control panel button
    const hideCpButton =
      this.strengthMeterHolder.querySelectorAll('.js-hide-buttons');
    const uiCp = this.strengthMeterHolder.querySelector('.ui-control-panel');
    if (hideCpButton) {
      hideCpButton.forEach((btn) => {
        btn.addEventListener('click', () => {
          uiCp.classList.toggle('hide');
          hideCpButton.forEach((btn) => {
            btn.classList.toggle('active');
          });
        });
      });
    }
    //currency/pair checks (within control panel)
    this.listTfChecks.forEach((check) => {
      check.addEventListener('click', () => {
        this.redrawGraphic(check);
      });
    });
    //tf checks (within control panel)
    this.listCurrencyChecks.forEach((check) => {
      check.addEventListener('click', () => {
        this.redrawGraphic(check);
        this.updateGroupButtons();
      });
    });
    //instruments groups checks (within control panel)
    this.listGroupChecks.forEach((check) => {
      check.addEventListener('click', () => {
        check.classList.toggle('enabled');
        const groupEnabled = check.classList.contains('enabled');
        const groupName = check.dataset.group;
        this.listCurrencyChecks.forEach((currCheck) => {
          if (currCheck.dataset.group == groupName) {
            if (groupEnabled) {
              currCheck.classList.add('enabled');
            } else {
              currCheck.classList.remove('enabled');
            }
          }
        });
        socketClient.currencyStrengthHistory().then((instrumentsData) => {
          this.initializeUserInterface(instrumentsData);
        });
      });
    });

    this.redrawGraphic = (checkDiv) => {
      checkDiv.classList.toggle('enabled');
      socketClient.currencyStrengthHistory().then((instrumentsData) => {
        this.initializeUserInterface(instrumentsData);
      });
    };
  }

  initializeUserInterface(instrumentData) {
    const listCurrencies = this.createNecessaryList(this.listCurrencyChecks);
    const timeframes = this.createNecessaryList(this.listTfChecks);
    const listGroups = this.createPairGroups(this.listCurrencyChecks);

    this.strengthMeter = new StrengthMeter(
      this.strengthMeterHolder,
      listCurrencies,
      timeframes,
      instrumentData,
      this.argumentsFunction,
      this.typeCalculator,
      listGroups
    );
    this.strengthMeter.drawStrengthMeter();
  }

  createNecessaryList(listChecks) {
    const result = [];
    listChecks.forEach((check) => {
      if (check.classList.contains('enabled')) {
        result.push(check.dataset.name);
      }
    });
    return result;
  }

  createPairGroups(listChecks) {
    const result = {};
    listChecks.forEach((check) => {
      if (check.classList.contains('enabled')) {
        const group = check.dataset.group;
        if (result[group]) {
          result[group].push(check.dataset.name);
        } else {
          result[group] = [];
          result[group].push(check.dataset.name);
        }
      }
    });

    return result;
  }
}
